import React, { useContext, useState } from 'react';
import ModalContext from '../../../context/ModalContext';
import AuthContext from '../../../context/AuthContext';
import { Button, CircularProgress } from '@mui/material';

const ConfirmActivationModal = ({ modalDetails }) => {
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const { company } = modalDetails;
  const isActivating = company.companyDetails.status === 'draft';

  const closeHandle = () => {
    modalCtx.closeModal();
  };

  const handleStatusChange = async () => {
    const { id } = company;
    const newStatus = isActivating ? 'active' : 'draft';
    setLoading(true);
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authCtx.token}`,
        },
        body: JSON.stringify({ status: newStatus }),
      });

      const data = await response.json();
      
      if (data.status === 'success') {
        modalCtx.setPageUpdate({ page: "Companies", companyId: id });
        closeHandle();
      } else {
        modalCtx.setDetails("validation-error", {});
        modalCtx.openModal();
      }
    } catch (error) {
      console.error(error);
      modalCtx.setDetails("validation-error", {});
      modalCtx.openModal();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-container">
      <div className='modal-header'>
        <h1>{isActivating ? 'Activate' : 'Deactivate'} Company</h1>
      </div>
      <div className="modal-body">
        <span>Are you sure you want to {isActivating ? 'activate' : 'deactivate'} this listing?</span><br/>
        <span style={{fontSize: "12px", color: "#555"}}>
          {isActivating 
            ? "It will be available for emergency services and coupons will be available on the app."
            : "It will no longer be available for emergency services and coupons will be hidden from the app."}
        </span>
      </div>
      <div className="modal-footer">
        <Button className="cancel-btn" onClick={closeHandle} disabled={loading}>CANCEL</Button>
        <Button onClick={handleStatusChange} disabled={loading}>{loading ? <CircularProgress size={16} style={{ color: "#fff" }} /> : ""} {isActivating ? "ACTIVATE" : "DEACTIVATE"}</Button>
      </div>
    </div>
  );
};

export default ConfirmActivationModal; 